@if(product(); as _product) {
<a [href]="_product.url"
   [attr.id]="_product.id">
  @for (item of _product.images; let index = $index; track index) {
  @if(index == 0) {
  <img role="presentation"
       [use]="item"
       loading="lazy"
       fetchPriority="high"
       size="product-card"
       fit="width" />
  }
  } @empty {
  <img role="presentation"
       [use]="fallbackImage"
       loading="lazy"
       fetchPriority="high"
       size="product-card"
       fit="width" />
  }
  @for(discount of (_product?.price?.discounts??[]); track discount.type) {
  <div class="discount"
       [attr.type]="discount.type"
       [attr.aria-label]="'PRODUCT.DISCOUNT' | translate:{amount:discount.type=='Amount'?(discount | price):discount.amount+'%'}">
    <!-- @if(discount.type=="Amount") {
    <span amount>{{ discount | price }}</span>
    }
    @if(discount.type=="Percent") {
    <span percent>{{ discount.amount }}%</span>
    } -->
  </div>
  }
  <span class="splash">{{_product.splash?.label}}</span>
  @if(_product.id.includes(',') || (_product?.addons?.length ?? 0) > 0) {
  <span class="customizer">{{ 'PRODUCT.HAS_CUSTOMIZER' | translate }}</span>
  }
  <span class="designer">{{ _product.designer }}</span>
  <span class="brand">{{ _product.brand }}</span>
  <span class="name"
        [title]="_product.name">{{ _product.name }}</span>
  <span price>
    @if((_product.price?.listPrice?.amount??0) > (_product.price?.salesPrice?.amount??0)) {
    <span list>{{ _product.price?.listPrice | price }}</span>
    }
    <span sales>{{ _product.price?.salesPrice | price }}</span>
  </span>
</a>
}
